export default __webpack_public_path__ + "03d23b5af02b9715997f915e3dd08c87.png";